import translations from '../i18n/translations.json';

export type TFilterStore = {
  isLoading: boolean;
  _loadingCount: number;

  pageSize: number;
  pageCurrent: number | null;
  pageCount: number | null;
  count: number;
  activeFilters: number;
  entryId?: string;
  vehicleListId?: string;
  vehicleFilterListId?: string;
  filters: [];
  vehicleList: [];

  lastError: string | null;

  // i18n
  translations: Record<string, string>;
  t: (key: string) => string;

  // sorting (share across components if needed)
  sort: string;
  setSort: (s: string) => void;

  // helpers
  startLoading: () => void;
  stopLoading: () => void;
  setError: (msg: string | null) => void;
};

export function createFilterStore(initial: Partial<TFilterStore> = {}): TFilterStore {
  /**
   * Loads the initial sort from the URL parameters
   * @returns sort string or null if not found
   */
  const loadSort = (): string | null => {
      const urlParams = new URLSearchParams(window.location.search);
      const sort = urlParams.get('sort');

      return sort;
  };

  /**
   * Loads the translations for the filters
   */
  const loadTranslations = () => {
      // Load translations for the current language
      const langTranslations = translations[document.documentElement.lang as keyof typeof translations] || {};

      return langTranslations;
  };

  const initialSort = loadSort() || 'created_at_desc';
  const initialTranslations = loadTranslations();

  const store: TFilterStore = {
    isLoading: false,
    lastError: null,
    _loadingCount: 0,

    pageSize: 12,
    pageCurrent: 1,
    pageCount: null,
    activeFilters: 0,
    count: 0,
    filters: [],
    vehicleList: [],

    translations: initialTranslations,

    sort: initialSort,

    t(key: string) {
      return store.translations[key] ?? key;
    },

    setSort(s: string) {
      store.sort = s;
    },

    startLoading() {
      this._loadingCount++;
      this.isLoading = true;
    },
    stopLoading() {
      this._loadingCount = Math.max(0, this._loadingCount - 1);
      this.isLoading = this._loadingCount > 0;
    },
    setError(msg: string | null) { store.lastError = msg; },

    ...initial,
  };
  return store;
}
